export default function FormatPhone(value: string) {
  const np = "N/P"
  if (value.length > 0) {
    const test = (value: string, compareValue: string): boolean => value.length <= compareValue.length && compareValue.slice(0, value.length) === value.toUpperCase()
    if (test(value, np)) {
      return value.toUpperCase()
    }
    if (value.length > 1 && test(value.slice(0, -1), np)) {
      return value.slice(0, -1).toUpperCase()
    }
  }
  var r = value.replace(/\D/g, "")
  if (r.length > 5) {
    r = r.replace(/^(\d{3})(\d{3})(\d{0,4}).*/, "$1-$2-$3")
  } else if (r.length > 2) {
    r = r.replace(/^(\d{3})(\d{0,4})/, "$1-$2")
  }
  if (r === value + '-') {
    // removing last minus symbol
    r = r.slice(0, -1)
  }
  return r
}
